import { Link } from "react-router-dom";
import { Scale, FileText, Users, Building2 } from "lucide-react";

const BLOQUES = [
  { icon: Scale, t: "Evaluación en contextos judiciales", d: "Evaluaciones psicopedagógicas solicitadas en el marco de procesos judiciales, con encuadre metodológico claro, resguardo de la confidencialidad y respeto por los derechos de las personas involucradas." },
  { icon: FileText, t: "Informes profesionales", d: "Elaboración de informes técnicos fundamentados, con lenguaje preciso y conclusiones sustentadas en la evidencia recogida durante el proceso de evaluación." },
  { icon: Users, t: "Intervenciones interdisciplinarias", d: "Trabajo articulado con abogados, peritos, psicólogos, médicos y equipos técnicos, favoreciendo una lectura integral del caso." },
  { icon: Building2, t: "Orientación a instituciones y profesionales", d: "Asesoramiento a instituciones educativas, organismos y profesionales sobre alcances, límites y pertinencia de la intervención psicopedagógica forense." },
];

export default function Forense() {
  return (
    <div data-testid="forense-page">
      <section className="border-b border-[#dcd5ce] bg-white">
        <div className="mx-auto max-w-7xl px-6 py-24">
          <p className="label-xs">Área exclusiva</p>
          <h1 className="mt-4 max-w-4xl text-5xl tracking-tight sm:text-6xl lg:text-7xl">
            Psicopedagogía <span className="italic text-[#c5a059]">Forense</span>
          </h1>
          <p className="mt-8 max-w-2xl leading-relaxed text-[#4a4744]">
            Un área especializada que articula el conocimiento psicopedagógico con el ámbito jurídico, aportando
            fundamentos técnicos sobre los procesos de aprendizaje, el desarrollo cognitivo y las trayectorias
            educativas de las personas involucradas en un proceso judicial.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-6 py-24">
        <div className="grid gap-6 md:grid-cols-2">
          {BLOQUES.map((b, i) => (
            <div key={b.t} data-testid={`forense-bloque-${i}`} className="card-nilo p-10">
              <b.icon size={22} className="text-[#c5a059]" strokeWidth={1.5} />
              <h2 className="mt-6 text-2xl leading-snug">{b.t}</h2>
              <p className="mt-4 text-sm leading-relaxed text-[#5e5a56]">{b.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 border border-[#c5a059]/40 bg-[#f4f1ec] p-10">
          <p className="label-xs">Encuadre profesional</p>
          <p className="mt-4 max-w-3xl leading-relaxed text-[#4a4744]">
            Toda intervención se realiza bajo estricta confidencialidad, siguiendo los principios éticos de la
            profesión y la normativa vigente. Los informes se elaboran exclusivamente a partir de la información
            recogida en el proceso de evaluación.
          </p>
          <Link to="/contacto" data-testid="forense-cta" className="mt-8 inline-block btn-gold rounded-full px-9 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">
            Consultar por una intervención
          </Link>
        </div>
      </section>
    </div>
  );
}
